import React                        from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotificationList             from './notifications/NotificationList';


const AudienceNotifications = (props) => {

    // Tomo los props
    const { readOnly } = props;
    
    // Accedo al store
    const audience = useSelector(state => state.audiences.audienceWork);

    // Renderizo
    return (
        <div className="row">
            {   audience 
                    ?
                        <NotificationList
                            audience = { audience }
                            readOnly = { readOnly }
                        />
                    : 
                        null
            }
        </div>
    );
};

export default AudienceNotifications;